import jwt_decode from 'jwt-decode';

export function FormatDataTableGlobal() : any {

    return {
      pagingType: 'full_numbers',
      pageLength: 10,
      order: [],
      destroy:true,
      dom: 'Bfrtip',
        language: {
          search: 'Buscar:',
          searchPlaceholder: 'Ingrese información...',
          paginate: {
            first: '<<',
            previous: '<<',
            next: '>>',
            last: '>>',
          }
        }
      };

}

export function FormatDataTableScroll() : any {

  return {
    pagingType: 'full_numbers',
    order: [],
    destroy:true,
    scrollY: '600px',
    scrollCollapse: true,
    scrollX: true,
    paging: false,
    fixedColumns:   {
      leftColumns: 2,
      rightColumns: 0, 
    },
    dom: 'Bfrtip',
      language: {
        search: 'Buscar:',
        searchPlaceholder: 'Ingrese información...',
        paginate: {
          first: '<<',
          previous: '<<',
          next: '>>',
          last: '>>',
        }
      }
    };

}

export function FormatDataTableScrollOne() : any {

  return {
    pagingType: 'full_numbers',
    order: [],
    destroy:true,
    scrollY: '600px',
    scrollCollapse: true,
    scrollX: true,
    paging: false,
    fixedColumns:   {
      leftColumns: 1,
      rightColumns: 0, 
    },
    dom: 'Bfrtip',
      language: {
        search: 'Buscar:',
        searchPlaceholder: 'Ingrese información...',
        paginate: {
          first: '<<',
          previous: '<<',
          next: '>>',
          last: '>>',
        }
      }
    };

}

export function FormatDataTableScrollTwo() : any {

  return {
    pagingType: 'full_numbers',
    order: [],
    destroy:true,
    scrollY: '600px',
    scrollCollapse: true,
    scrollX: true,
    paging: false,
    fixedColumns:   {
      leftColumns: 2,
      rightColumns: 0, 
    },
    dom: 'Bfrtip',
      language: {
        search: 'Buscar:',
        searchPlaceholder: 'Ingrese información...',
        paginate: {
          first: '<<',
          previous: '<<',
          next: '>>',
          last: '>>',
        }
      }
    };

}


export function FormatDataTableGlobalFive() : any {

  return {
    pagingType: 'full_numbers',
    pageLength: 5,
    order: [],
    destroy:true,
    dom: 'Bfrtip',
      language: {
        search: 'Buscar:',
        searchPlaceholder: 'Ingrese información...',
        paginate: {
          first: '<<',
          previous: '<<',
          next: '>>',
          last: '>>',
        }
      }
    };

}

export function DropdownSettingsStado() : any {

  return{
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 2,
    enableCheckAll: false
  };
}


export function TableOneSearch(): any {

  return {
    pagingType: 'full_numbers',
    pageLength: 5,
    order: [],
    destroy:true,
    dom: 'frtip',
    language: {
      search: 'Buscar:',
      searchPlaceholder: 'Ingrese información...',
      paginate: {
        first: '<<',
        previous: '<<',
        next: '>>',
        last: '>>',
      }
    }
  };

}

export function GetPermisses(id) {

  let token = localStorage.getItem('token')
  let listPermis = jwt_decode(token);
  let permisos_menu: number[] = []

  listPermis['permisses'].map((dato) => {

    if (dato > 0) {

      if (permisos_menu.find(element => element == dato)) {

      } else {
        permisos_menu.push(Number(dato))
      }
    }

  });
  permisos_menu = permisos_menu.sort((a, b) => a - b);

  let info = permisos_menu.filter( n =>  n == id)

  if(info[0] == null){
    return false;
  }
  return true;
  
}

export function FormatterPesonNotDecimal(): any {
  return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0
  })
}

export function FormatterDolar(): any {
  return new Intl.NumberFormat('es-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
  })
}

export function FormatterPeso(): any {
  return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 2
  })
}